import React from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { Create, useForm, useSelect } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { CAMPAIGN_REWARD_TYPE_OPTION } from '../../constants';

export const CampaignRewardCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm();

  const { selectProps: earnCampaignSelectProps } = useSelect({
    resource: 'earn-campaign',
    optionLabel: 'name',
  });

  const campaignRewardTypes = CAMPAIGN_REWARD_TYPE_OPTION;

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Earn Campaign"
          name={['earnCampaignId']}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...earnCampaignSelectProps} />
        </Form.Item>

        <Form.Item
          label="Reward Type"
          name={['rewardType']}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...campaignRewardTypes} />
        </Form.Item>
        <Form.Item
          label="Reward Value"
          name={['rewardValue']}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
